import React from "react";
import { CompanionThreadsProvider } from "../contexts/CompanionThreadsContext";
import { ChatAudioPreferencesProvider } from "../contexts/ChatAudioPreferencesContext";

const withCompanionProviders = <Props extends object>(Component: React.ComponentType<Props>) => {
  const Wrapped = (props: Props) => (
    <CompanionThreadsProvider>
      <ChatAudioPreferencesProvider>
        <Component {...props} />
      </ChatAudioPreferencesProvider>
    </CompanionThreadsProvider>
  );

  const componentName = Component.displayName ?? Component.name ?? "Component";
  Wrapped.displayName = `withCompanionProviders(${componentName})`;

  return Wrapped;
};

export default withCompanionProviders;
